export default function Keyboard({ activeKey, keyStatus }) {
  const rows = [
    [
      { key: '`', shift: '~' },
      { key: '1', shift: '!' },
      { key: '2', shift: '@' },
      { key: '3', shift: '#' },
      { key: '4', shift: '$' },
      { key: '5', shift: '%' },
      { key: '6', shift: '^' },
      { key: '7', shift: '&' },
      { key: '8', shift: '*' },
      { key: '9', shift: '(' },
      { key: '0', shift: ')' },
      { key: '-', shift: '_' },
      { key: '=', shift: '+' },
      { key: 'delete', label: '⌫', width: 'w-20' }
    ],
    [
      { key: 'tab', label: '⇥', width: 'w-16' },
      { key: 'q' },
      { key: 'w' },
      { key: 'e' },
      { key: 'r' },
      { key: 't' },
      { key: 'y' },
      { key: 'u' },
      { key: 'i' },
      { key: 'o' },
      { key: 'p' },
      { key: '[', shift: '{' },
      { key: ']', shift: '}' },
      { key: '\\', shift: '|', width: 'w-16' }
    ],
    [
      { key: 'caps', label: '⇪', width: 'w-20' },
      { key: 'a' },
      { key: 's' },
      { key: 'd' },
      { key: 'f' },
      { key: 'g' },
      { key: 'h' },
      { key: 'j' },
      { key: 'k' },
      { key: 'l' },
      { key: ';', shift: ':' },
      { key: "'", shift: '"' },
      { key: 'return', label: '⏎', width: 'w-24' }
    ],
    [
      { key: 'shift', label: '⇧', width: 'w-28' },
      { key: 'z' },
      { key: 'x' },
      { key: 'c' },
      { key: 'v' },
      { key: 'b' },
      { key: 'n' },
      { key: 'm' },
      { key: ',', shift: '<' },
      { key: '.', shift: '>' },
      { key: '/', shift: '?' },
      { key: 'shift', label: '⇧', width: 'w-28' }
    ]
  ]

  const bottomRow = [
    { key: 'fn', label: 'fn', width: 'w-12' },
    { key: 'control', label: '⌃', width: 'w-12' },
    { key: 'option', label: '⌥', width: 'w-12' },
    { key: 'command', label: '⌘', width: 'w-16' },
    { key: ' ', label: '', width: 'flex-1' },
    { key: 'command', label: '⌘', width: 'w-16' },
    { key: 'option', label: '⌥', width: 'w-12' },
    { key: '←', label: '←', width: 'w-12' },
    { key: '↑↓', label: '↑↓', width: 'w-12' },
    { key: '→', label: '→', width: 'w-12' }
  ]

  const getKeyClassName = (keyObj) => {
    const key = keyObj.key
    let className = 'keyboard-key rounded-md text-xs font-medium flex flex-col items-center justify-center transition-all duration-150 h-12'
    
    const specialKeys = ['delete', 'tab', 'caps', 'return', 'shift', 'command', 'option', 'control', 'fn', '←', '↑↓', '→']
    if (specialKeys.includes(key)) {
      className += ' text-gray-500 text-[10px]'
    }
    
    // Only check for active state (white background, black text)
    if (activeKey === key || (key === ' ' && activeKey === ' ')) {
      className += ' active'
    }
    
    return className
  }

  const renderKey = (keyObj) => {
    const displayLabel = keyObj.label || keyObj.key.toUpperCase()
    return (
      <div
        key={`${keyObj.key}-${keyObj.label || ''}`}
        className={`${getKeyClassName(keyObj)} ${keyObj.width || 'w-12'}`}
        data-testid={`key-${keyObj.key}`}
      >
        {keyObj.shift && !keyObj.label ? (
          <>
            <span className="text-[10px] text-gray-500">{keyObj.shift}</span>
            <span className="text-sm">{keyObj.key}</span>
          </>
        ) : keyObj.key === ' ' ? (
          <span></span>
        ) : (
          <span className="text-sm">{displayLabel}</span>
        )}
      </div>
    )
  }

  return (
    <div className="stat-card rounded-xl p-4 border" data-testid="keyboard">
      <div className="space-y-1.5">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="flex gap-1.5 justify-center">
            {row.map((keyObj, keyIndex) => renderKey(keyObj))}
          </div>
        ))}
        <div className="flex gap-1.5 justify-center">
          {bottomRow.map((keyObj, keyIndex) => renderKey(keyObj))}
        </div>
      </div>
    </div>
  )
}
